import { render } from "./ProfileSectionEditor.vue?vue&type=template&id=a0fba62e"
import script from "./ProfileSectionEditor.vue?vue&type=script&lang=js"
export * from "./ProfileSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__